<template>
  <div class="card">
    <div class="card-header">
      <h1>Mi Perfil</h1>
    </div>
    <div class="card-body">
      <form ref="profile_form" @submit.prevent="handleProfileUpdate">
        <div v-if="user.attributes">
          <base-input
            label="Nombre"
            prepend-icon="fas fa-user"
            placeholder="Tu nombre"
            v-model="user.attributes.name"
          />
          <validation-error :errors="apiValidationErrors.name" />
          <base-input
            label="Apellidos"
            prepend-icon="fas fa-user"
            placeholder="Tus apellidos"
            v-model="user.attributes.last_name"
          />
          <validation-error :errors="apiValidationErrors.last_name" />
          <base-input
            label="Email"
            prepend-icon="fas fa-envelope"
            placeholder="Email"
            v-model="user.attributes.email"
          />
          <validation-error :errors="apiValidationErrors.email" />
        </div>
        <div class="my-4">
          <base-button
            type="button"
            class="btn btn-sm btn-default hover-apolo"
            native-type="submit"
          >
            Actualizar
          </base-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "UserEditCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
    };
  },

  methods: {
    async handleProfileUpdate() {
      if(this.user.attributes.password == null || this.user.attributes.password == 'importare'){
        this.user.attributes.password = 'importare';
        this.user.attributes.password_confirmation = 'importare';
      }
        try {
          await this.$store.dispatch("profile/update", this.user);

          this.resetApiValidation();
          this.$notify({
            type: "success",
            message: "Perfil actualizado satisfactoriamente.",
            duration: -1
          });

          await this.$store.getters["profile/me"];
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.setApiValidation(error.response.data.errors);
        }
    },
  },
};
</script>
